import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CentralComponent} from './central/central.component';
import {CarsComponent} from './cars/cars.component';
import {DriversComponent} from './drivers/drivers.component';
import {MapComponent} from './map/map.component';
import {LoginComponent} from './login/login.component';
import {OverviewComponent} from './overview/overview.component';
import {AirportcarsComponent} from './airportcars/airportcars.component';
import {AirportKioskComponent} from './airport-kiosk/airport-kiosk.component';
import {VouchersComponent} from './vouchers/vouchers.component';
import {OrdersComponent} from './orders/orders.component';
import {PosComponent} from './pos/pos.component';
import {ProfileComponent} from './profile/profile.component';

const routes: Routes = [
    {
        path: 'central', component: CentralComponent, children: [
            {path: 'overview', component: OverviewComponent, data: {title: 'Overview'}},
            {path: 'cars', component: CarsComponent, data: {title: 'Cars'}},
            {path: 'driver', component: DriversComponent, data: {title: 'Driver'}},
            {path: 'driver/:driverIdentifier', component: DriversComponent, data: {title: 'Driver'}},
            {path: 'airportcars', component: AirportcarsComponent, data: {title: 'Airport Cars'}},
            {path: 'airport-kiosk', component: AirportKioskComponent, data: {title: 'Airport Kiosk'}},
            {path: 'vouchers', component: VouchersComponent, data: {title: 'Vouchers'}},
            {path: 'orders', component: OrdersComponent, data: {title: 'Orders'}},
            {path: 'pos', component: PosComponent, data: {title: 'POS'}},
            {path: 'map', component: MapComponent, data: {title: 'Map'}},
            {path: 'profile', component: ProfileComponent, data: {title: 'My Profile'}},
            {path: '**', component: OverviewComponent, data: {title: 'Overview'}},
        ]
    },
    {path: 'login', component: LoginComponent},
    {path: '', component: LoginComponent},
    {path: '**', component: LoginComponent}
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
